import {BaseFormModel} from '../base-form-model';
import {TabReportResult} from '../report/tab-report-result';

export class QuickbooksReports extends BaseFormModel<QuickbooksReports> {
    itemTypeSales: TabReportResult;
    paymentInformation: TabReportResult;
}
